import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Bold14,
  Bold16,
  Container,
  Main,
  OutlineButton,
  ProductButton,
  ProductCard,
  ProductContainerDev,
  ResponsiveContainer,
} from "../components/common";
import EmptyContainer from "../components/EmptyContainer";
import ProductCardProd from "../components/ProductCardProd";
import ProductCardDev from "../components/ProductCardDev";
import StartingModal from "../components/StartingModal";
import AppContext from "../context/AppContext";
import { NewBankConnectRedirect } from "./NewBankConnectRedirect";

function BCHome(props) {
  const history = useHistory();
  const [profile, setProfile] = useState(null);
  const [trailActivated, setTrailActivated] = useState(false);
  const context = useContext(AppContext);

  useEffect(() => {
    const resp = context.token;
    if (!resp) return;
    const respJSON = JSON.parse(resp);
    setProfile({
      name: respJSON.UserData.Name,
    });
  }, []);

  const startTrial = async () => {
    let fT = context.token;
    const ftData = JSON.parse(fT);
    var myHeaders = new Headers();
    myHeaders.append("token", ftData.Token);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    let response = await fetch(
      "https://dashboardapi.finbox.in/v1/user/starttrial",
      requestOptions
    );
    const result = await response.text();
    const json = JSON.parse(result);
    if (json.Status) {
      setTrailActivated(true);
    } else {
      setTrailActivated(false);
      alert(json.Error);
    }
  };

  return (
    <>
      {context.firstLogin ? (
        <StartingModal
          trailActivated={trailActivated}
          onPrimaryClick={() => startTrial()}
          onSecondaryClick={() =>
            window.open(
              "https://support643206.typeform.com/to/TZ0Joj",
              "_blank"
            )
          }
          onExploreClick={() => window.location.reload()}
          onFailedAction={() =>
            window.open(
              "https://support643206.typeform.com/to/TZ0Joj",
              "_blank"
            )
          }
        />
      ) : (
        ""
      )}
      {profile && context.productStage ? (
        <Main>
          {/* <BreadCrumbsNavbar
            loc={[{ name: "Bank Connect", link: props.location.pathname }]}
          /> */}
          <Container style={{minHeight:"fit-content"}}>
            {JSON.parse(context.productStage).bank_connect == "dev" ? (
              <NewBankConnectRedirect />
            ) : JSON.parse(context.productStage).bank_connect == "prod" ? (
              <NewBankConnectRedirect />
            ) : JSON.parse(context.productStage).bank_connect == "" ? (
              <EmptyContainer
                heading="BankConnect"
                content={
                  <>
                  BankConnect enriches transaction data from bank account statements.
                  <br /><br />
                  Users can upload PDF manually or automatically via net banking login.
                  </>
                }
                image="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/signup2.svg"
                link="https://support643206.typeform.com/to/yFcJ9O"
              />
            ) : (
              ""
            )}
            {/* )} */}
          </Container>
        </Main>
      ) : (
        ""
      )}
    </>
  );
}
export default BCHome;
